import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import FontSizes from '../../constants/FontSizes';
import { MainColors } from '../../constants/Colors';

const VotedOnMessageBox = (props) => {
    return (
        <View style={[styles.container, props.style]}>
            <View style={{ flex: 1 }}>
                <Text style={styles.text}>{props.messageTitle}</Text>
                <Text style={styles.subtext}>{props.messageText}</Text>
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        borderRadius: 8,
        padding: 10,
        alignItems: 'center',
        borderWidth: 2,
        borderColor: MainColors.secondary,
        flexDirection: 'row',
    },
    text: {
        fontSize: FontSizes.medium,
        fontWeight: '500',
        letterSpacing: 0.5,
        lineHeight: 24,
        color: MainColors.darkGray,
        marginBottom: 10,
        textAlign: 'center'
    },
    subtext: {
        color: MainColors.darkGray,
        fontSize: FontSizes.medium,
        fontWeight: '400',
        letterSpacing: 0.5,
        lineHeight: 24,
        textAlign: 'center'
    }
});

export default VotedOnMessageBox;
